export const DEFAULT_THUMBNAIL = '/images/favicon/hackathon-favicon-180x180.png';